import { render, staticRenderFns } from "./DetailedInfo.vue?vue&type=template&id=fce63aa0"
import script from "./DetailedInfo.vue?vue&type=script&lang=js"
export * from "./DetailedInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailedInfo.vue?vue&type=style&index=0&id=fce63aa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports